import { Component, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { breadcrumbItem } from "src/app/components/breadcrumbs/breadcrumbs.model";
import { BreadcrumbService } from "src/app/services/breadcrumb";
import { ChartType } from "./apex.model";
import {
  alerts,
  statData, transactions
} from "./data";

import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";
import moment from "moment";
import { CookieService } from "ngx-cookie-service";
import { TranslatePipe } from "src/app/core/pipes/translate.pipe";
import { AlertService } from "src/app/core/services/AlertService/alert.service";
import { PermissionService } from "src/app/core/services/permission.service";
import { ApiService } from "src/app/services/api";
import { TimezoneService } from "src/app/services/timezone";


@Component({
  selector: "app-admin-overview",
  templateUrl: "./admin-overview.component.html",
  styleUrls: ["./admin-overview.component.scss"],
  providers: [TranslatePipe],
})
export class AdminOverviewComponent implements OnInit {
  GLOBALURL: String = this.ApiService.getBaseURL()
  headerToken = { 'Content-Type': 'application/json', 'Authorization': this.cookieService.get('token') }
  httpOptions = { headers: new HttpHeaders(this.headerToken) };
  currency: any = this.cookieService.get("currency");

  breadcrumbItems: breadcrumbItem[] = [
    {
      label: "Overview",
      active: true,
      url: "/overview",
    }
  ];

  statData: any[];
  revenueBarChart: ChartType;
  transactions: any[] = [];
  alerts: any[] = [];
  cardsData: any = {
    merchants: 0,
    orders: 0,
    products: 0,
  };
  selectDateoption: any = "Today";
  prevSelectDateoption: any = "Yesterday";
  prevStartDate: any = this.timezoneService.get()().subtract(1, 'day').startOf('day');
  prevEndDate: any = this.timezoneService.get()().subtract(1, 'day').endOf('day');
  prevStartDateDisplay: any = this.prevStartDate.unix();
  prevEndDateDisplay: any = this.prevEndDate.unix();
  prevStartDateDisplayFormatted: any = this.timezoneService.get()
    .unix(this.prevStartDateDisplay)
    .format("MMM Do YY");
  prevEndDateDisplayFormatted: any = this.timezoneService.get()
    .unix(this.prevEndDateDisplay)
    .format("MMM Do YY");
  startDate: any = this.timezoneService.get()().startOf('day');
  endDate: any = this.timezoneService.get()().endOf('day');
  customEndDate: any = this.timezoneService.get()().endOf('day');
  startDateDisplay: any = this.startDate.unix();
  endDateDisplay: any = this.endDate.unix();
  customEndDateDisplay: any = this.customEndDate.unix();
  startDateDisplayFormatted: any = this.timezoneService.get()
    .unix(this.startDateDisplay)
    .format("MMM D YYYY");
  endDateDisplayFormatted: any = this.timezoneService.get()
    .unix(this.endDateDisplay)
    .format("MMM D YYYY");

    page = 4;
    active = 5;
    itemsPP: any = 10;
    totalElements: any = [];
    p: number = 1;

    invalidDates: moment.Moment[] = [
      this.timezoneService.get()().add(2, "days"),
      this.timezoneService.get()().add(3, "days"),
      this.timezoneService.get()().add(5, "days"),
    ];

    isInvalidDate = (m: moment.Moment) => {
      return this.invalidDates.some((d) => d.isSame(m, "day"));
    };

    dateFilteroptions = [
      "Today",
      "Yesterday",
      "This Week",
      "This Month",
      "This Quarter",
      "Custom",
      // "Last 7 days",
      // "Last month",
      // "Last 3 months",
      // "Last 12 months",
      // "Month to date",
      // "Quater to date",
      // "Year to date",
      // "All the time"
    ];

  revenueLoader: boolean = false;
  emptyRevenue: boolean = false;

  Timezone: any;
  access: boolean = true;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private translatePipe: TranslatePipe,
    private modalService: NgbModal,
    private http: HttpClient,
    private ApiService: ApiService,
    private cookieService: CookieService,
    private timezoneService: TimezoneService,
    private router: Router,
    public permissionService: PermissionService,
    private toastr: AlertService,
  ) {
    this.breadcrumbService.setValue(this.breadcrumbItems);
    this.Timezone = this.timezoneService.get();
  }

  ngOnInit(): void {
    if (this.currency == undefined || this.currency == null) {
      this.currency = "$";
    }
    if (!this.permissionService.canAccessSuper('Dashboard', 1)) {
      this.toastr.error("You are not authorized to perform this operation.");
      this.router.navigate(['/403']);
      this.access = false
      return;
    }

    // this.fetchData();
    this.getReports();
  }

  async selectedDateOption(type) {
    console.log("I WAS TRIGGERED", type);
    this.selectDateoption = type;
    if (type === "This Month") {
      this.prevSelectDateoption = "Last Month";
      this.prevStartDate = this.timezoneService.get()().subtract(1, "months").startOf("month");
      this.prevEndDate = this.timezoneService.get()().subtract(1, "months").endOf("month");
      this.prevStartDateDisplay = this.prevStartDate.unix();
      this.prevEndDateDisplay = this.prevEndDate.unix();
      this.prevStartDateDisplayFormatted = this.timezoneService.get()
        .unix(this.prevStartDateDisplay)
        .format("MMM Do YY");
      this.prevEndDateDisplayFormatted = this.timezoneService.get()
        .unix(this.prevEndDateDisplay)
        .format("MMM Do YY");
      this.startDate = this.timezoneService.get()().startOf("month");
      this.endDate = this.timezoneService.get()().endOf("month");
      this.startDateDisplay = this.startDate.unix();
      this.endDateDisplay = this.endDate.unix();
      this.startDateDisplayFormatted = this.timezoneService.get()
        .unix(this.startDateDisplay)
        .format("MMM D YYYY");
      this.endDateDisplayFormatted = this.timezoneService.get()
        .unix(this.endDateDisplay)
        .format("MMM D YYYY");
      this.getCommissionReport();
      this.getTopCardReport();
      this.getTopMerchantsReport();
      this.getLatestTransactions();
    } else if (type === "Last Month") {
      this.prevSelectDateoption = "Month before last month";
      this.prevStartDate = this.timezoneService.get()().subtract(2, "months").startOf("month");
      this.prevEndDate = this.timezoneService.get()().subtract(2, "months").endOf("month");
      this.prevStartDateDisplay = this.prevStartDate.unix();
      this.prevEndDateDisplay = this.prevEndDate.unix();
      this.prevStartDateDisplayFormatted = this.timezoneService.get()
        .unix(this.prevStartDateDisplay)
        .format("MMM Do YY");
      this.prevEndDateDisplayFormatted = this.timezoneService.get()
        .unix(this.prevEndDateDisplay)
        .format("MMM Do YY");
      this.startDate = this.timezoneService.get()().subtract(1, "months").startOf("month");
      this.endDate = this.timezoneService.get()().subtract(1, "months").endOf("month");
      this.startDateDisplay = this.startDate.unix();
      this.endDateDisplay = this.endDate.unix();
      this.startDateDisplayFormatted = this.timezoneService.get()
        .unix(this.startDateDisplay)
        .format("MMM D YYYY");
      this.endDateDisplayFormatted = this.timezoneService.get()
        .unix(this.endDateDisplay)
        .format("MMM D YYYY");
      this.getCommissionReport();
      this.getTopCardReport();
      this.getTopMerchantsReport();
      this.getLatestTransactions();
    }else if (type === "Yesterday"){
      this.prevSelectDateoption = "Day Before Yesterday";
      this.prevStartDate = this.timezoneService.get()().subtract(2, "days").startOf("day");
      this.prevEndDate = this.timezoneService.get()().subtract(2, "days").endOf("day");
      this.prevStartDateDisplay = this.prevStartDate.unix();
      this.prevEndDateDisplay = this.prevEndDate.unix();
      this.prevStartDateDisplayFormatted = this.timezoneService.get()
        .unix(this.prevStartDateDisplay)
        .format("MMM Do YY");
      this.prevEndDateDisplayFormatted = this.timezoneService.get()
        .unix(this.prevEndDateDisplay)
        .format("MMM Do YY");
      this.startDate = this.timezoneService.get()().subtract(1, "days").startOf("day");
      this.endDate = this.timezoneService.get()().subtract(1, "days").endOf("day");
      this.startDateDisplay = this.startDate.unix();
      this.endDateDisplay = this.endDate.unix();
      this.startDateDisplayFormatted = this.timezoneService.get()
        .unix(this.startDateDisplay)
        .format("MMM D YYYY");
      this.endDateDisplayFormatted = this.timezoneService.get()
        .unix(this.endDateDisplay)
        .format("MMM D YYYY");
      this.getCommissionReport();
      this.getTopCardReport();
      this.getTopMerchantsReport();
      this.getLatestTransactions();
    }
     else if (type === "Today") {
      this.prevSelectDateoption = "Yesterday";
      this.prevStartDate = this.timezoneService.get()().subtract(1, "days").startOf("day");
      this.prevEndDate = this.timezoneService.get()().subtract(1, "days").endOf("day");
      this.prevStartDateDisplay = this.prevStartDate.unix();
      this.prevEndDateDisplay = this.prevEndDate.unix();
      this.prevStartDateDisplayFormatted = this.timezoneService.get()
        .unix(this.prevStartDateDisplay)
        .format("MMM Do YY");
      this.prevEndDateDisplayFormatted = this.timezoneService.get()
        .unix(this.prevEndDateDisplay)
        .format("MMM Do YY");
      this.startDate = this.timezoneService.get()().startOf("day");
      this.endDate = this.timezoneService.get()().endOf("day");
      this.startDateDisplay = this.startDate.unix();
      this.endDateDisplay = this.endDate.unix();
      this.startDateDisplayFormatted = this.timezoneService.get()
        .unix(this.startDateDisplay)
        .format("MMM D YYYY");
      this.endDateDisplayFormatted = this.timezoneService.get()
        .unix(this.endDateDisplay)
        .format("MMM D YYYY");
      this.getCommissionReport();
      this.getTopCardReport();
      this.getTopMerchantsReport();
      this.getLatestTransactions();
    } else if (type === "This Week") {
      this.prevSelectDateoption = "Last Week";
      this.prevStartDate = this.timezoneService.get()().subtract(1, "week").startOf("week");
      this.prevEndDate = this.timezoneService.get()().subtract(1, "week").endOf("week");
      this.prevStartDateDisplay = this.prevStartDate.unix();
      this.prevEndDateDisplay = this.prevEndDate.unix();
      this.prevStartDateDisplayFormatted = this.timezoneService.get()
        .unix(this.prevStartDateDisplay)
        .format("MMM Do YY");
      this.prevEndDateDisplayFormatted = this.timezoneService.get()
        .unix(this.prevEndDateDisplay)
        .format("MMM Do YY");
      this.startDate = this.timezoneService.get()().startOf("week");
      this.endDate = this.timezoneService.get()().endOf("week");
      this.startDateDisplay = this.startDate.unix();
      this.endDateDisplay = this.endDate.unix();
      this.startDateDisplayFormatted = this.timezoneService.get()
        .unix(this.startDateDisplay)
        .format("MMM D YYYY");
      this.endDateDisplayFormatted = this.timezoneService.get()
        .unix(this.endDateDisplay)
        .format("MMM D YYYY");
      this.getCommissionReport();
      this.getTopCardReport();
      this.getTopMerchantsReport();
      this.getLatestTransactions();
    } else if (type === "This Quarter") {
      this.prevSelectDateoption = "Last Quarter";
      this.prevStartDate = this.timezoneService.get()().subtract(1, "quarter").startOf("quarter");
      this.prevEndDate = this.timezoneService.get()().subtract(1, "quarter").endOf("quarter");
      this.prevStartDateDisplay = this.prevStartDate.unix();
      this.prevEndDateDisplay = this.prevEndDate.unix();
      this.prevStartDateDisplayFormatted = this.timezoneService.get()
        .unix(this.prevStartDateDisplay)
        .format("MMM Do YY");
      this.prevEndDateDisplayFormatted = this.timezoneService.get()
        .unix(this.prevEndDateDisplay)
        .format("MMM Do YY");
      this.startDate = this.timezoneService.get()().quarter(this.timezoneService.get()().quarter()).startOf("quarter");
      this.endDate = this.timezoneService.get()().quarter(this.timezoneService.get()().quarter()).endOf("quarter");
      this.startDateDisplay = this.startDate.unix();
      this.endDateDisplay = this.endDate.unix();
      this.startDateDisplayFormatted = this.timezoneService.get()
        .unix(this.startDateDisplay)
        .format("MMM D YYYY");
      this.endDateDisplayFormatted = this.timezoneService.get()
        .unix(this.endDateDisplay)
        .format("MMM D YYYY");
      this.getCommissionReport();
      this.getTopCardReport();
      this.getTopMerchantsReport();
      this.getLatestTransactions();
    } else if (type === "Last 3 months") {
      this.prevSelectDateoption = "3 months before last 3 months";
    } else if (type === "Last 12 months") {
      this.prevSelectDateoption = "12 months before last 12 months";
    } else if (type === "Month to date") {
    } else if (type === "Quater to date") {
    } else if (type === "Year to date") {
    } else if (type === "All the time") {
      this.prevSelectDateoption = "All the time";
    }
  }
  a1
  a2
  customDate: any = "";
  async selectedDate(event: any) {
    console.log("SELECTED DATE");

    // Store references to the date picker values
    const value = {
        start: moment(this.a1),
        end: moment(this.a2)
    };

    // Set start and end dates for the current selection
    this.startDate = this.timezoneService.get()(value.start).startOf("day");
    this.endDate = this.timezoneService.get()(value.end).endOf("day");

    // Calculate the difference in days to set the previous date range
    const diff = this.endDate.diff(this.startDate, "days") + 1;
    this.prevStartDate = this.startDate.clone().subtract(diff, "days");
    this.prevEndDate = this.endDate.clone().subtract(diff, "days");

    // Adjust the start and end dates if needed based on your business logic
    const nativeDate = new Date(this.a1);
    if (this.startDate.month() !== nativeDate.getMonth() || this.startDate.date() !== nativeDate.getDate()) {
        console.log("Adjusting Dates");
        this.startDate.add(1, 'days');
        this.endDate.add(1, 'days');
        this.prevStartDate.add(1, 'days');
        this.prevEndDate.add(1, 'days');
    }

    // Set display values for both current and previous date ranges
    this.startDateDisplay = this.startDate.unix();
    this.endDateDisplay = this.endDate.unix();
    this.prevStartDateDisplay = this.prevStartDate.unix();
    this.prevEndDateDisplay = this.prevEndDate.unix();

    this.startDateDisplayFormatted = this.startDate.format("MMM D YYYY");
    this.endDateDisplayFormatted = this.endDate.format("MMM D YYYY");
    this.prevStartDateDisplayFormatted = this.prevStartDate.format("MMM D YYYY");
    this.prevEndDateDisplayFormatted = this.prevEndDate.format("MMM D YYYY");

    this.prevSelectDateoption = `${this.prevStartDateDisplayFormatted} to ${this.prevEndDateDisplayFormatted}`;
    this.selectDateoption = "custom";
    this.customDate = `${this.startDateDisplayFormatted} to ${this.endDateDisplayFormatted}`;

    // Check for invalid dates and fetch the report
    if (this.prevEndDateDisplayFormatted !== "Invalid date") {
        await this.getCommissionReport();
        await this.getTopCardReport();
        await this.getTopMerchantsReport();
        await this.getLatestTransactions();
    }
}

onLimitSelected(e) {
  this.itemsPP = e;
  this.p = 1;
// this.itemsPP = e;
  // this.loadPage();
  this.getLatestTransactions();
}

updatePage = (event) => {
  this.p = event;
  // this.loadPage();
  this.getLatestTransactions();
};

  getReports() {
    this.getCommissionReport();
    this.getTopMerchantsReport();
    this.getLatestTransactions();
    this.getTopCardReport();
    this.getLatestAlerts();
  }


  getCommissionReport() {
    this.revenueLoader = true;
    let graphCurrency: string = this.currency;

    const params = {
      reportName: "commission_superadmin_report",
      query: {
        startDate: this.startDateDisplay,
        endDate: this.endDateDisplay,
      }
    }

    this.http.post(this.GLOBALURL + "/reports/query", params, this.httpOptions)
      .subscribe((response: any) => {
        if (response?.data?.intervals?.length > 0) {
          let dates = [];
          let data = [];

          response.data.intervals.forEach((element) => {
            let date = element.key;

            const parsedDate = this.Timezone(element.key_as_string, "MM-DD-YYYY");
            date = parsedDate.format("MMM DD");

            data.push(element.commission);
            dates.push(date);
          });

          this.revenueBarChart = {
            chart: {
              height: 340,
              type: 'area',
              stacked: true,
              toolbar: {
                  show: false
              },
              zoom: {
                  enabled: true
              }
            },
            plotOptions: {
              bar: {
                  horizontal: false,
                  columnWidth: '15%',
                  borderRadius: 5,
                  endingShape: 'rounded'
              },
            },
            dataLabels: {
              enabled: false
            },
            series: [{
              name: 'Commission',
              data: data,
            }],
            labels: dates,
            yaxis: {
              labels: {
                formatter: (val) => {
                  return `${graphCurrency}${val.toLocaleString("en-US")}`;
                }
              }
            },
            colors: ['#202020'],
            legend: {
              position: 'bottom',
            },
            fill: {
              opacity: 1
            },
            tooltip: {
              x: {
                formatter: (val: number) => {
                  console.log(`${graphCurrency} ${val.toLocaleString("en-US")}`)
                  return `${graphCurrency}${val.toLocaleString("en-US")}`;
                }
              }
            }
          };

          this.emptyRevenue = false;
          this.revenueLoader = false;
        } else {
          this.initializeEmptyRevenueChart();
          this.emptyRevenue = true;
          this.revenueLoader = false;
        }
      },
      (error) => {
        this.initializeEmptyRevenueChart();
        this.emptyRevenue = true;
        this.revenueLoader = false;
        console.error("Error getting revenue data", error);
      });
  }

  topMerchants: any[] = [];
  topMerchant: any;
  maxTotal: number = 0;
  getTopMerchantsReport() {
    const params = {
      "reportName": "top_merchants_superadmin_report",
      "query": {
        startDate: this.startDateDisplay,
        endDate: this.endDateDisplay,
      }
    }

    this.http.post(this.GLOBALURL + "/reports/query", params, this.httpOptions)
      .subscribe((response: any) => {
        if (response.success) {
          if (response.data.length > 0) {
            this.maxTotal = Math.max(...response.data.map(merchant => parseFloat(merchant.total)));
            this.topMerchant = response.data[0];
            this.topMerchants = response.data;
          }
        }
      },
      (error) => {
        console.error("Error getting top merchants data", error);
      });
  }

  getLatestTransactions() {
    const limit: number = Number(this.itemsPP); // Alternatively, parseInt(this.itemsPP, 10)
      const offset: number = Number(this.p);
    let params = {
      "reportName": "recent_transactions_superadmin_report",
      "query": {
        startDate: this.startDateDisplay,
        endDate: this.endDateDisplay,
        limit: limit || 10,
        offset: offset || 0,
      }
    };

    this.http.post(this.GLOBALURL + "/reports/query", params, this.httpOptions)
      .subscribe((response: any) => {
        if (response.success) {
          this.transactions = response.data;
          this.totalElements = response?.total;
              setTimeout(() => {
                this.setPaginateTexts();
              }, 100);
        }
      },
      (error) => {
        console.error("Error getting latest transactions data", error);
      })
  }

  setPaginateTexts() {
    const next = document.querySelector(".pagination-next a");
    const prev = document.querySelector(".pagination-previous a");
    const nextDisabled = document.querySelector(".pagination-next > span");
    const prevDisabled = document.querySelector(".pagination-previous > span");

    console.log("test", next)
    console.log("test", prev)
    console.log("test", nextDisabled)
    console.log("test", prevDisabled)

    this.translatePipe.transform("Next")
      .subscribe(res => {
        if (next) {
          next.textContent = res;
        }
        if (nextDisabled) {
          nextDisabled.textContent = res;
        }
      },
      (error) => {});

    this.translatePipe.transform("Previous")
      .subscribe(res => {
        if (prev) {
          prev.textContent = res;
        }
        if (prevDisabled) {
          prevDisabled.textContent = res;
        }
      },
      (error) => {});
  }

  getTopCardReport() {
    const params = {
      "reportName": "top_card_superadmin_report",
      "query": {
        startDate: this.startDateDisplay,
        endDate: this.endDateDisplay,
      }
    }

    this.http.post(this.GLOBALURL + "/reports/query", params, this.httpOptions)
      .subscribe((res: any) => {
        if (res.success) {
          this.cardsData = res.data;
        }
      },
      (error) => {
        console.error("Error getting top card data", error);
      });
  }

  getLatestAlerts() {
    // this.alerts = alertResponse; // Mock data
    this.http.get(this.GLOBALURL + "/subscription/alert", this.httpOptions)
      .subscribe((response: any) => {
        if (response.length > 0) {
          this.alerts = response; // Should work with the actual data
        }
      },
      (error) => {
        console.error("Error getting latest alerts data", error);
      });
  }

  fetchData() {
    this.statData = statData;
    // this.revenueBarChart = revenueBarChart;
    this.transactions = transactions;
    this.alerts = alerts;

    window.dispatchEvent(new Event("resize"));
  }

  calculateProgress(total: number, maxTotal: number): number {
    return (total / maxTotal) * 100;
  }

  openModal(content: any) {
    this.modalService.open(content, { centered: true });
  }

  convertedDates: any = {};
  convertDate = (date: any) => {
    if (!this.convertedDates[date]) {
      if (date) {
        // console.log("DATE", this.Timezone(date));
        this.convertedDates[date] = this.Timezone(date)
          .format("MMM DD, YYYY");

        // console.log("CONVERTED DATES", this.convertedDates);
      } else {
        return "N/A";
      }
    }

    return this.convertedDates[date];
  };

  convertedUnixDates = {};
  convertUnixDate = (id: any, date: any) => {
    if (!this.convertedUnixDates[id]) {
      if (date) {
        this.convertedUnixDates[id] = this.timezoneService
          .get()(date * 1000)
          .format("MMM DD, YYYY");
        // console.log("CONVERTED UNIX DATES", this.convertedUnixDates);
      } else {
        return "";
      }
    }
    return this.convertedUnixDates[id];
  }

  initializeEmptyRevenueChart() {
    let graphCurrency: string = this.currency;
    const months: string[] = [];
    const currentMonth = this.Timezone().month();  // Get the current month (0-indexed)
    for (let month = 0; month <= currentMonth; month++) {
      // Create a moment object for each month and format it as "MMM"
      months.push(this.Timezone().month(month).format("MMM"));
    }

    this.revenueBarChart = {
      chart: {
        height: 340,
        type: 'area',
        stacked: true,
        toolbar: {
            show: false
        },
        zoom: {
            enabled: true
        }
      },
      plotOptions: {
        bar: {
            horizontal: false,
            columnWidth: '15%',
            borderRadius: 5,
            endingShape: 'rounded'
        },
      },
      dataLabels: {
        enabled: false
      },
      series: [{
        name: 'Commission',
        data: months.map((month) => { return 0;}),
      }],
      labels: months,
      yaxis: {
        labels: {
          formatter: (val) => {
            return "$" + val;
          }
        }
      },
      colors: ['#202020'],
      legend: {
        position: 'bottom',
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        x: {
          formatter: (val: number) => {
            return `${graphCurrency} ${val}`;
          }
        }
      }
    };
  }



}
